import { faImage, faPaperclip, faPlus, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip } from '@material-ui/core';
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import { push } from "connected-react-router";
import MaterialTable from 'material-table';
import 'primeicons/primeicons.css';
import 'primereact/resources/primereact.css';
import * as React from 'react';
import { SpinnerComponent } from 'react-element-spinner';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import { Button, Col, FormGroup, Input, Label, Navbar, Row } from "reactstrap";
import { MiddleModal, TabPanel } from '../../components/ReusableComponents/Bars/BasicComponents';
import { Uploader } from '../../components/Uploader';
import { CallAxiosRequest } from '../../Helpers/axiosHelpers';
import { YoonitRequest, YoonitResponse } from '../../Interfaces/Interfaces';
import { Login, Logout, UpdateZendeskID } from '../../redux/actions/AuthActions';
import { IStore, IUserData } from '../../redux/constants';
import { ParagraphEditor } from './ParagraphEditor';


const cloneDeep = require('lodash/cloneDeep');
declare var require: any
const moment = require('moment');
const NoTicket = require("../../Assets/imgs/NoTicket.png") as string;

const mapStateToProps = (state: IStore) => ({
    userData: state.auth.UserData,
    lang: state.language.value,
    history: state.history,
    URL: state.auth.UserData.yoonitGetURL,
    theme: state.theme
});

const dispatchProps = { push, Login, Logout, UpdateZendeskID }
export interface TicketsPageProps {
    lang: string;
    userData: IUserData;
    push: any;
    URL: string;
    theme: any;
    t: any;
    UpdateZendeskID: any;
}

export interface TicketsPageState {
    showFilter: boolean;
    isLoading: boolean;
    openNewTicket: boolean;
    openNewAccount: boolean;
    SearchTerm: string;
    TicketName: string;
    TicketBody: string;
    TPOptions: any[];
    TPFilterOptions: any[];
    TSOptions: any[];
    TTypesOptions: any[];
    dates: any[];
    TPSelectedOption: any;
    TTypeSelectedOption: any;
    TSSelectedOption: any;
    TPFilteredOption: any[];
    TSFilteredOption: any[];
    Columns: any[];
    Files: any[];
    AttachmentImg: string;
    AttachmentName: string;
    attachIsUploading: number;
    tableHasRecords: boolean;
    fromDate: any;
    toDate: any;
    filterDate: boolean;
    ccEmail: string;
    emailList: any[];
    fullName: string;
    EmailsValidted: boolean;
    value: number;
    TotalMyTickets: number;
    TotalAllTickets: number;
}
let headerParameters: any = {
    Token: ""
}
let priorityOptions = [{ value: "low", label: "Low" }, { value: "normal", label: "Normal" }, { value: "high", label: "High" }, { value: "urgent", label: "Urgent" }];
let typeOptions = [{ value: 0, label: "None" }, { value: 1, label: "Question" }, { value: 2, label: "Incident" }, { value: 3, label: "Problem" }, { value: 4, label: "Task" }];
let statusOptions = [
    { value: "new", label: <Label><span className="NewStatus mr-2">N</span> New</Label> },
    { value: "open", label: <Label><span className="OpenStatus mr-2">O</span>Open</Label> },
    { value: "pending", label: <Label><span className="PendingStatus mr-2">P</span>Pending</Label> },
    { value: "solved", label: <Label>< span className="SolvedStatus mr-2" > S</span> Solved</Label> },
    { value: "closed", label: <Label><span className="ClosedStatus mr-2">C</span>Closed</Label> }
];

export function validateEmail(email: any) {
    if (!email)
        return false;
    let regex = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}/igm;
    var a = regex.test(email);
    return a;
}
class TicketsMainPage extends React.Component<TicketsPageProps, TicketsPageState> {
    state = {
        showFilter: true, openNewTicket: false, tableHasRecords: true, SearchTerm: '',
        TPOptions: [],
        TPFilterOptions: [],
        TSOptions: [],
        TTypesOptions: [],
        TPSelectedOption: { value: "", label: "" },
        TTypeSelectedOption: { value: "", label: "" },
        TSSelectedOption: { value: "", label: "" },
        TPFilteredOption: [],
        TSFilteredOption: [],
        TicketName: '',
        TicketBody: '',
        Files: [],
        AttachmentImg: '',
        AttachmentName: '',
        attachIsUploading: 0,
        Columns: [{ title: 'TicketId', field: 'Id' },
        { title: 'Subject', field: 'Subject' }],
        dates: [],
        fromDate: new Date(new Date().setDate(new Date().getDate() - 7)) as any,
        toDate: new Date() as any,
        filterDate: false,
        ccEmail: "", isLoading: false, emailList: [], openNewAccount: false, fullName: '', EmailsValidted: false,
        value: 0, TotalMyTickets: 0,
        TotalAllTickets: 0,
    }
    componentDidMount = () => {
        headerParameters.Token = this.props.userData.Token;
        if (this.props.userData.ZendeskID === null) {
            this.setState({ openNewAccount: true })
        }
        this.PrioritybOpt(priorityOptions)
        this.StatusOpt(statusOptions);
        this.TypeOpt(typeOptions);
        let datesArray: any = [];
        datesArray.push(this.state.fromDate, this.state.toDate);
        this.setState({ dates: datesArray });
    }
    handleChange = (event: React.ChangeEvent<any>, value: any) => {
        this.setState({ value })
        console.log(value)
    };
    PrioritybOpt = (priorityOptions: any) => {
        var _priorityOptions = [];
        for (var k = 0; k < priorityOptions.length; k++) {
            _priorityOptions.push({ value: priorityOptions[k].value, label: priorityOptions[k].label });
        }
        this.setState({ TPOptions: _priorityOptions, TPSelectedOption: _priorityOptions[0] });
    }
    StatusOpt = (statusOptions: any) => {
        var _statusOptions = [];
        for (var k = 0; k < statusOptions.length; k++) {
            _statusOptions.push({ value: statusOptions[k].value, label: statusOptions[k].label });
        }
        this.setState({ TSOptions: _statusOptions, TSSelectedOption: _statusOptions[0] });
    }
    TypeOpt = (typesOptions: any) => {
        var _typesOptions = [];
        for (var k = 0; k < typesOptions.length; k++) {
            _typesOptions.push({ value: typesOptions[k].value, label: typesOptions[k].label });
        }
        this.setState({ TTypesOptions: _typesOptions, TTypeSelectedOption: _typesOptions[0] });
    }
    addAccount = () => {
        if (this.ValidateInput(this.state.fullName)) {
            let ActionParams: YoonitRequest<any> = {
                ObjData: {
                    Name: this.state.fullName
                }
            };
            this.setState({ isLoading: true })
            CallAxiosRequest<YoonitRequest<any>, YoonitResponse<any>>(this.props.userData.TechAPIURL, 'Ticket/AddTicketingAccount',
                ActionParams,
                headerParameters,
                (result: YoonitResponse<any>) => {
                    this.setState({ isLoading: false })
                    if (result.data.ActionRes) {
                        this.props.UpdateZendeskID(result.data.LiveRes);
                        this.setState({ openNewAccount: false })
                    }
                    else {
                        toastr.error('', 'Please Contact Us!');
                    }
                },
                (e: any) => { },
                (value: any) => String(value)
            );
            this.closeNewTicket()
        }
        else {
            this.setState({ isLoading: false })
            toastr.error('', 'Please fill all fields!');
        }
    }
    addTicket = () => {

        if (this.ValidateInput(this.state.TicketName) && this.ValidateInput(this.state.TicketBody) && this.state.attachIsUploading === 0
            && (!this.state.ccEmail || this.state.EmailsValidted)) {
            let ActionParams: YoonitRequest<any> = {
                ObjData: {
                    Subject: this.state.TicketName,
                    Body: this.state.TicketBody,
                    ZID: this.props.userData.ZendeskID,
                    PriorityName: this.state.TPSelectedOption.value,
                    TypeID: this.state.TTypeSelectedOption.value,
                    Attachments: this.state.Files,
                    EmailCCs: this.state.emailList
                }
            };
            this.setState({ isLoading: true })
            CallAxiosRequest<YoonitRequest<any>, YoonitResponse<any>>(this.props.userData.TechAPIURL, 'Ticket/AddClientTicket',
                ActionParams,
                headerParameters,
                (result: YoonitResponse<any>) => {
                    this.setState({ isLoading: false })
                    if (result.data.IntRes > 0) {
                        toastr.success("", this.props.t('Added'))
                        this.setState({ tableHasRecords: true }, this.refreshTable);
                    }
                    else {
                        toastr.error('', this.props.t('ErrorContactingServer'));
                    }
                },
                (e: any) => { },
                (value: any) => String(value)
            );
            this.closeNewTicket()
        }
        else {
            this.setState({ isLoading: false })
            if (this.state.ccEmail && !this.state.EmailsValidted) {
                toastr.error('', 'Please enter valid Emails!');
            }
            else
                toastr.error('', 'Please fill all fields!');
        }


    }
    customRequest = (file: any) => {
        let data = new FormData();
        data.append('file', file);
        let files: any = this.state.Files;
        files.push({ FileData: file.Data.substring(file.Data.indexOf(",") + 1), FileName: file.name, ContentType: file.type });
        this.setState({ Files: files });
    }
    customRemove = (removedFile: any) => {
        let fileToRemove: any = this.state.Files.filter((file: any) => file.FileName === removedFile.FileName)[0];
        let files = this.state.Files.filter((file: any) => file.FileName !== removedFile.FileName);
        this.setState({ Files: files });
    }
    inputOnchange = (e: any) => {
        let array = this.state.ccEmail && this.state.ccEmail.split(',') ? this.state.ccEmail.split(',') : [];
        let _EmailsValidted: boolean = true;
        for (var i = 0; i < array.length; i++) {
            if (!validateEmail(array[i])) {
                _EmailsValidted = false;
                break;
            }
        }
        this.setState({
            emailList: array,
            EmailsValidted: _EmailsValidted
        })
        this.setState({ [e.target.name]: e.target.value } as any)
    }
    ValidateInput = (value: any): boolean => {
        if (value !== null && value !== undefined && value !== "" && value !== 0)
            return true;
        return false;
    }
    showFilterBar = () => {
        this.setState({ showFilter: !this.state.showFilter })
    }
    closeFilterBar = () => {
        this.setState({ showFilter: false })
    }
    openNewTicket = () => {
        this.setState({
            openNewTicket: true,
            TicketName: "",
            TicketBody: "<div>&nbsp;</div>",
            TPSelectedOption: { label: '', value: '' },
            TSSelectedOption: { label: '', value: '' },
            AttachmentImg: '',
            AttachmentName: '',
            ccEmail: '',
            emailList: [],
            Files: []
        })
    }
    closeNewTicket = () => {
        this.setState({ openNewTicket: false })
    }
    openNewAccount = () => {
        this.setState({
            openNewAccount: true,
            fullName: ''
        })
    }
    closeNewAccount = () => {
        this.setState({ openNewAccount: false })
    }

    navigateToTicket = (TicketID: number) => {
        console.log(TicketID)
        this.props.push('/ServiceDesk/Ticket?Id=' + TicketID);
    }
    Editor = React.createRef<ParagraphEditor>();
    SetTicketBody = (key: number, value: string) => {
        this.setState({ TicketBody: value })
    }
    ticketTypeOnchange = (value: any) => {
        this.setState({ TTypeSelectedOption: value });
    }
    ticketPriorityOnchange = (value: any) => {
        this.setState({ TPSelectedOption: value });
    }
    PriorityFilterOnchange = (e: any) => {
        this.setState({ TPFilteredOption: e.value }, this.refreshTable);
    }
    StatusFilterOnchange = (e: any) => {
        this.setState({ TSFilteredOption: e.value }, this.refreshTable);
    }
    filterFirstTable = (e: any) => {
        this.setState({ SearchTerm: e.target.value }, this.refreshTable)
    }
    tableTPOnChange = (value: number, ticketId: string) => {
        let ActionParams: YoonitRequest<any> = {
            ObjData: {
                TicketID: ticketId,
                PriorityID: +(value)
            }
        };
        CallAxiosRequest<YoonitRequest<any>, YoonitResponse<any>>(this.props.userData.TechAPIURL, 'Ticket/ChangePriority',
            ActionParams,
            headerParameters,
            (result: YoonitResponse<any>) => {
                if (result.data.IntRes > 0) {
                    toastr.success("", this.props.t('Updated'))
                    this.refreshTable();
                }
                else {
                    toastr.error('', this.props.t('ErrorContactingServer'));
                }
            },
            (e: any) => { },
            (value: any) => String(value)
        );
    }
    tableTCOnChange = (value: number, ticketId: string) => {
        let ActionParams: YoonitRequest<any> = {
            ObjData: {
                TicketID: ticketId,
                CategoryID: +(value)
            }
        };
        CallAxiosRequest<YoonitRequest<any>, YoonitResponse<any>>(this.props.userData.TechAPIURL, 'Ticket/ChangeCategory',
            ActionParams,
            headerParameters,
            (result: YoonitResponse<any>) => {
                if (result.data.IntRes > 0) {
                    toastr.success("", this.props.t('Updated'))
                    this.refreshTable();
                }
                else {
                    toastr.error('', this.props.t('ErrorContactingServer'));
                }
            },
            (e: any) => { },
            (value: any) => String(value)
        );
    }
    tableRef: any = React.createRef();
    refreshTable = () => {
        this.tableRef.current.onQueryChange();
    }
    datesOnChange = (newValue: any) => {
        var dates: any = newValue.value;
        this.setState({ dates });
        if (dates && dates[0] && dates[1]) {
            var fromDate: any = new Date(dates[0]), mnth = ("0" + (fromDate.getMonth() + 1)).slice(-2), day = ("0" + fromDate.getDate()).slice(-2);
            var fromDateStr: any = [fromDate.getFullYear(), mnth, day].join("-");
            var toDate: any = new Date(dates[1]), mnth = ("0" + (toDate.getMonth() + 1)).slice(-2), day = ("0" + toDate.getDate()).slice(-2);
            var toDateStr: any = [toDate.getFullYear(), mnth, day].join("-");
            this.setState({ dates });
            this.setState({
                fromDate: fromDateStr,
                toDate: toDateStr,
                filterDate: true
            }, this.refreshTable)
        }
    }
    render() {
        let ref = this;
        return (<div className="mt-3">
            <SpinnerComponent loading={this.state.isLoading} position="inline" color="#00ad0f" />
            <Navbar className="borderbottom h60 bordertop pl0 mb-3 ticketNavbar" >
                <div className="w100p paddingButtons">
                    {this.props.userData.ZendeskID !== null ?
                        <Button className=" ButtonsModal " onClick={this.openNewTicket}>  <FontAwesomeIcon icon={faPlus} className="cursor-pointer mr-2" /> {this.props.t('NewTicket')} </Button> : <Button className=" ButtonsModal mr-3" onClick={this.openNewAccount}>  <FontAwesomeIcon icon={faPlus} className="cursor-pointer mr-2" /> {this.props.t('SetUpAccount')} </Button>}
                    <Tabs
                        value={this.state.value}
                        onChange={this.handleChange}
                        indicatorColor="primary"
                        textColor="primary"
                        variant="scrollable"
                        scrollButtons="auto"
                        orientation="horizontal"
                        aria-label="scrollable auto tabs example"
                        className="d-inline-flex"
                    >
                        <Tab key={0} label="My Tickets" />,
                        <Tab key={1} label="Company Tickets" />,
                    </Tabs>
                </div>
            </Navbar>

            <MiddleModal
                openModal={this.state.openNewTicket}
                titleText={this.props.t('CreateNewTicket')}
                showClose={true}
                body={
                    <div>
                        <Row>
                            <Col col-md={12}>
                                <FormGroup >
                                    <Label for="Subject" className="LabelCreate2 d-contents  font-14" > {this.props.t('Subject')}: </Label>
                                    <Input
                                        type="text"
                                        name="TicketName"
                                        bsSize="lg"
                                        className="Inputs"
                                        onChange={this.inputOnchange}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col col-md={12}>
                                <FormGroup >
                                    <Label for="ccEmail" className="LabelCreate2 d-contents  font-14 ccLabel" > Cc: </Label>
                                    <Input
                                        type="text"
                                        name="ccEmail"
                                        bsSize="lg"
                                        className="Inputs"
                                        placeholder={"Please use commas to separate Emails."}
                                        onChange={this.inputOnchange}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <FormGroup>
                                    <Label for="ticketDesc" className="LabelCreate2 d-contents font-14" >{this.props.t('Description')}:</Label>

                                    <ParagraphEditor
                                        ref={this.Editor}
                                        key={"TicketReply"}
                                        index={1}
                                        id={"TicketReply"}
                                        setContent={this.SetTicketBody}
                                        ETContent={this.state.TicketBody}
                                    >
                                    </ParagraphEditor>
                                </FormGroup>
                            </Col>
                        </Row>
                        {false &&
                            <div className="d-flex">
                                <div>
                                    <div className="backgroundGrey p-2 fitcontent mb-2">
                                        <FontAwesomeIcon icon={faImage} className="mr-2 d-inline-flex iconGrey" />
                                        <Label className="d-inline-flex LabelCreate2 mr-3 ml-3 clickableText"  > esm picture.png </Label>
                                        <FontAwesomeIcon icon={faTrashAlt} className="ml-3 iconGrey cursor-pointer" />
                                    </div>
                                    <div className="backgroundGrey p-2 fitcontent mb-2">
                                        <FontAwesomeIcon icon={faImage} className="mr-2 d-inline-flex iconGrey" />
                                        <Label className="d-inline-flex LabelCreate2 mr-3 ml-3 clickableText"  > esm picture.png </Label>
                                        <FontAwesomeIcon icon={faTrashAlt} className="ml-3 iconGrey cursor-pointer" />
                                    </div>
                                </div>
                                <div className="ml-auto p-2">
                                    <Button className="EmptyBtn" > <FontAwesomeIcon icon={faPaperclip} className="mr-2" /> {this.props.t('Upload')} </Button>
                                </div>
                            </div>
                        }
                        <Uploader
                            translate={this.props.t}
                            customRequest={this.customRequest}
                            customRemove={this.customRemove}
                        />
                    </div>
                }
                closeModal={this.closeNewTicket}
                ActionClick={this.addTicket}
                ButtonText={this.props.t('Add')}
            />
            <MiddleModal
                smallerModal={true}
                openModal={this.state.openNewAccount}
                titleText={this.props.t('Create Service Desk Account')}
                showClose={true}
                body={
                    <div>
                        <SpinnerComponent loading={this.state.isLoading} position="inline" color="#00ad0f" />
                        <Row>
                            <Col col-md={12}>
                                <FormGroup >
                                    <Label for="fullName" className="LabelCreate2 d-contents  font-14" > {this.props.t('FullName')}: </Label>
                                    <Input
                                        type="text"
                                        name="fullName"
                                        bsSize="lg"
                                        className="Inputs"
                                        onChange={this.inputOnchange}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        {this.props.userData.UserName && <Row>
                            <Col col-md={12}>
                                <FormGroup >
                                    <Label for="Email" className="LabelCreate2 d-contents  font-14" > {this.props.t('Email')}: </Label>
                                    <Input
                                        type="text"
                                        name="Email"
                                        value={this.props.userData.UserName}
                                        bsSize="lg"
                                        className="Inputs"
                                        disabled
                                        onChange={this.inputOnchange}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>}
                    </div>
                }
                closeModal={this.closeNewAccount}
                ActionClick={this.addAccount}
                ButtonText={this.props.t('Add')}
            />


            <TabPanel key={0} value={this.state.value} index={0}>
                <div className="tableDiv">
                    <Label className="RequestedTicket"> Requested Tickets ({this.state.TotalMyTickets}) </Label>
                    <MaterialTable
                        tableRef={this.tableRef}
                        key="TicketsTable"
                        title={''}
                        onRowClick={(event: any, rowData: any) => { this.navigateToTicket(rowData.Id) }}
                        columns={
                            [
                                {
                                    title: this.props.t('Status'), field: 'Status', defaultGroupOrder: 0,
                                    cellStyle: () => {
                                        return { backgroundColor: '#f8f9f9', height: '30px' };
                                    },
                                    customSort: () => 0 //to check
                                },
                                {
                                    title: this.props.t('TicketId'), field: 'Id',
                                    render: data => <>{this.ReturnStatus(data.Status)} {data.Id.toString().padStart(3, '0')} </>
                                },
                                { title: 'Id', field: 'TicketID', hidden: true },
                                { title: 'Status', field: 'Status', hidden: true },
                                { title: this.props.t('Subject'), field: 'Subject' },
                                {
                                    title: this.props.t('Priority'),
                                    field: 'PriorityName'
                                },
                                {
                                    title: this.props.t('CreationDate'), field: 'CreationDate',
                                    render: data => moment(data.CreationDate || new Date()).format('DD MMM YYYY [,] h:mm A')
                                }
                            ]
                        }
                        data={
                            (query) =>
                                new Promise((resolve, reject) => {
                                    let tableParams = {
                                        ObjData: {
                                            SearchTerm: ref.state.SearchTerm,
                                            SkipTerm: query.page * query.pageSize,
                                            TakeTerm: query.pageSize,
                                            OrderByTerm: 'CreationDate',
                                            OrderByDir: -1,
                                            FromDate: moment(ref.state.fromDate || new Date()).format('YYYY-MM-DD'),
                                            ToDate: moment(ref.state.toDate || new Date()).format('YYYY-MM-DD'),
                                            FilterDate: ref.state.filterDate,
                                            TPFilter: ref.state.TPFilteredOption,
                                            TSFilter: ref.state.TSFilteredOption,
                                            ZID: ref.props.userData.ZendeskID === null ? "" : ref.props.userData.ZendeskID

                                        }
                                    };
                                    if (query.orderBy) {
                                        tableParams.ObjData.OrderByTerm = query.orderBy.field ? query.orderBy.field.toString() : "";
                                        tableParams.ObjData.OrderByDir = query.orderDirection === 'asc' ? 1 : -1;
                                    }
                                    CallAxiosRequest<YoonitRequest<any>, YoonitResponse<any>>(this.props.userData.TechAPIURL, 'Ticket/GetClientTable',
                                        tableParams,
                                        headerParameters,
                                        (res: YoonitResponse<any>) => {
                                            let result = [], totalCount = 0;
                                            if (res.data.TablesRes) {
                                                result = res.data.TablesRes.ReturnList;
                                                for (var i in result) {
                                                    if (result[i].Status == 'new') {
                                                        result[i].Status = 'New';
                                                    }
                                                    if (result[i].Status == 'open') {
                                                        result[i].Status = 'Opened';
                                                    }
                                                    if (result[i].Status == 'pending') {
                                                        result[i].Status = 'Pending';
                                                    }
                                                    if (result[i].Status == 'solved') {
                                                        result[i].Status = 'Solved';
                                                    }
                                                    if (result[i].Status == 'closed') {
                                                        result[i].Status = 'Closed';
                                                    }
                                                }
                                                totalCount = cloneDeep(res.data.TablesRes.TotalDisplayRecords);
                                                var temp = cloneDeep(totalCount);
                                                this.setState({ TotalMyTickets: cloneDeep(temp) })
                                                if (totalCount === 0) {
                                                    this.setState({ tableHasRecords: false });
                                                }

                                            }
                                            else {
                                                this.setState({ tableHasRecords: false });
                                            }
                                            resolve({
                                                data: result,
                                                page: query.page,
                                                totalCount: totalCount,
                                            });
                                        },
                                        (e: any) => { console.log(e); },
                                        (value: any) => String(value)
                                    );
                                })
                        }
                        options={{
                            search: false,
                            defaultExpanded: true,
                            paging: true,
                            showTextRowsSelected: false,
                            pageSize: 20,
                            emptyRowsWhenPaging: false,
                            pageSizeOptions: [],
                        }}
                    />
                </div>
            </TabPanel>
            <TabPanel key={1} value={this.state.value} index={1}>
                <div className="tableDiv">
                    <Label className="RequestedTicket"> Requested Tickets ({this.state.TotalAllTickets}) </Label>
                    <MaterialTable
                        tableRef={this.tableRef}
                        key="TicketsTable"
                        title={''}
                        onRowClick={(event: any, rowData: any) => { this.navigateToTicket(rowData.Id) }}
                        columns={

                            [
                                {
                                    title: this.props.t('Status'), field: 'Status', defaultGroupOrder: 0,
                                    cellStyle: () => {
                                        return { backgroundColor: '#f8f9f9', height: '30px' };
                                    },
                                    customSort: () => 0 //to check
                                },
                                {
                                    title: this.props.t('TicketId'), field: 'Id',
                                    render: data => <>{this.ReturnStatus(data.Status)} {data.Id.toString().padStart(3, '0')} </>
                                },
                                { title: 'Id', field: 'TicketID', hidden: true },
                                { title: 'Status', field: 'Status', hidden: true },
                                { title: this.props.t('Subject'), field: 'Subject' },
                                { title: this.props.t('Requester'), field: 'OwnerName' },
                                {
                                    title: this.props.t('Priority'),
                                    field: 'PriorityName'
                                },
                                {
                                    title: this.props.t('CreationDate'), field: 'CreationDate',
                                    render: data => moment(data.CreationDate || new Date()).format('DD MMM YYYY [,] h:mm A')
                                }
                            ]
                        }
                        data={
                            (query) =>
                                new Promise((resolve, reject) => {
                                    let tableParams = {
                                        ObjData: {
                                            SearchTerm: ref.state.SearchTerm,
                                            SkipTerm: query.page * query.pageSize,
                                            TakeTerm: query.pageSize,
                                            OrderByTerm: 'CreationDate',
                                            OrderByDir: -1,
                                            FromDate: moment(ref.state.fromDate || new Date()).format('YYYY-MM-DD'),
                                            ToDate: moment(ref.state.toDate || new Date()).format('YYYY-MM-DD'),
                                            FilterDate: ref.state.filterDate,
                                            TPFilter: ref.state.TPFilteredOption,
                                            TSFilter: ref.state.TSFilteredOption,
                                            ZID: ref.props.userData.ZendeskID === null ? "" : ref.props.userData.ZendeskID

                                        }
                                    };
                                    if (query.orderBy) {
                                        tableParams.ObjData.OrderByTerm = query.orderBy.field ? query.orderBy.field.toString() : "";
                                        tableParams.ObjData.OrderByDir = query.orderDirection === 'asc' ? 1 : -1;
                                    }

                                    CallAxiosRequest<YoonitRequest<any>, YoonitResponse<any>>(this.props.userData.TechAPIURL, 'Ticket/GetOrganizationTickets',
                                        tableParams,
                                        headerParameters,
                                        (res: YoonitResponse<any>) => {
                                            var result = [], totalCount = 0;
                                            if (res.data.TablesRes) {
                                                result = res.data.TablesRes.ReturnList;
                                                for (var i in result) {
                                                    if (result[i].Status == 'new') {
                                                        result[i].Status = 'New';
                                                    }
                                                    if (result[i].Status == 'open') {
                                                        result[i].Status = 'Opened';
                                                    }
                                                    if (result[i].Status == 'pending') {
                                                        result[i].Status = 'Pending';
                                                    }
                                                    if (result[i].Status == 'solved') {
                                                        result[i].Status = 'Solved';
                                                    }
                                                    if (result[i].Status == 'closed') {
                                                        result[i].Status = 'Closed';
                                                    }
                                                }
                                                totalCount = res.data.TablesRes.TotalDisplayRecords;
                                                if (totalCount === 0) {
                                                    this.setState({ tableHasRecords: false });
                                                }
                                            } else {
                                                this.setState({ tableHasRecords: false });
                                            }
                                            this.setState({ TotalAllTickets: totalCount })
                                            resolve({
                                                data: result,
                                                page: query.page,
                                                totalCount: totalCount,
                                            });
                                        },
                                        (e: any) => { console.log(e); },
                                        (value: any) => String(value)
                                    );
                                })
                        }
                        options={{
                            search: false,
                            defaultExpanded: true,
                            paging: true,
                            showTextRowsSelected: false,
                            pageSize: 20,
                            emptyRowsWhenPaging: false,
                            pageSizeOptions: [],
                        }}
                    />
                </div>
            </TabPanel>
            {false &&
                <div className="insideMain padingf2em " >
                    <Col sm="12" md="12" lg="12" className="mx-auto d-table h-100 mt100 ">
                        <div className=" text-center p10" >
                            <img src={NoTicket} alt="" className="mt-3" />
                            <div className="d-block mt-3 text-center m10">
                                <Label className="text-Grey font-32 t-bold d-block mb-2"> {this.props.t('NoTickets')} </Label>
                                <Label className="text-Grey font-24 d-block m-0"> {this.props.t("NoTicketsMessage")} </Label>
                                <Button className=" ButtonsModal ml-2 mt-5" onClick={this.openNewTicket}>  <FontAwesomeIcon icon={faPlus} className="cursor-pointer mr-2" /> {this.props.t('NewTicket')} </Button>
                            </div>
                        </div>
                    </Col>
                </div>
            }

        </div>);
    }
    ReturnStatus = (status: any) => {
        if (status === "new" || status === "New") {
            return <Tooltip title="New"><span className="NewStatus cursor-pointer">N</span></Tooltip>;
        }
        if (status === "open" || status === "Opened") {
            return <Tooltip title="Open"><span className="OpenStatus cursor-pointer">O</span></Tooltip>;
        }
        if (status === "pending" || status === "Pending") {
            return <Tooltip title="Pending"><span className="PendingStatus cursor-pointer">P</span></Tooltip >;
        }
        if (status === "solved" || status === "Solved") {
            return <Tooltip title="Solved"><span className="SolvedStatus cursor-pointer">S</span></Tooltip >;
        }
        if (status === "closed" || status === "Closed") {
            return <Tooltip title="Closed"><span className="ClosedStatus cursor-pointer">C</span></Tooltip >;
        }

        return status;
    }
}
export default withTranslation()(connect(mapStateToProps, dispatchProps)(TicketsMainPage));
